import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';

const NewForm = ({
  children,
  initial,
  validationSchema,
  onSubmit,
  onError,
}) => {
  const formik = useFormik({
    initialValues: initial,
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  const [errors, updateErrors] = React.useState(formik.errors);

  React.useEffect(() => {
    if (!formik.isValid) {
      onError(formik.errors);
      updateErrors(errors);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }, [formik.isSubmitting]);

  const hasErrors =
    formik.touched &&
    Object.keys(formik.touched).length > 0 &&
    formik.touched.constructor === Object;
  const preparedErrors = Object.fromEntries(
    Object.entries(formik.errors).map(([k, v]) => [k, [v]])
  );
  const contents = children({
    formik: formik,
    change: formik.handleChange,
    data: formik.values,
    errors: hasErrors ? preparedErrors : {},
    submit: formik.handleSubmit,
    setFields: formik.setValues,
  });

  return <form onSubmit={formik.handleSubmit}>{contents}</form>;
};

NewForm.propTypes = {
  initial: PropTypes.object.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onSubmit: PropTypes.func.isRequired,
  formatErrors: PropTypes.func,
  validationSchema: PropTypes.object,
};

export default NewForm;
